import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosInterceptor } from "../utils/axios-utils";
import axios from "axios";
import { config } from "../config";
import { profile360_actions } from "../Component/Profile360/js/slice";


export const fetchNavbar = createAsyncThunk(
  "frontdeskProfile",
  async (state, { getState, rejectWithValue, dispatch }) => {
    try {
      const { data } = await AxiosInterceptor.get(`${config.RESERVATION_API}/v1/staff/auth`);
      dispatch(profile360_actions.setHotelData(data.result.data));
      return data;
    } catch (err) {
      console.log('Error: >>>', err);

      localStorage.clear();
      window.location.href = '/';

      throw rejectWithValue({
        status: {
          apiSuccess: false,
          apiMessage:
            err?.result?.message ||
            "Something went wrong please try again later",
        },
      });
    }
  }
);
